import { render } from "./index.vue?vue&type=template&id=3f766a7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3f766a7e&scoped=true&lang=css"

import exportComponent from "D:\\SZK180142\\git-project\\officalm\\cignacmb-static\\cignacmb-m\\campaign\\bocomcc\\bwhyf\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f766a7e"]])

export default __exports__